module.exports = __webpack_public_path__ + "static/media/Loading.e3da939b.gif";